import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  };

  useEffect(() => {
    // Handle Emergent Google Auth session_id in URL fragment
    if (window.location.hash.includes("session_id=")) {
      const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
      if (sid) {
        (async () => {
          try {
            const role = localStorage.getItem("nh_google_role") || "youth";
            const { data } = await api.post("/auth/google", { session_id: sid, role });
            if (data.token) localStorage.setItem("nh_token", data.token);
            setUser(data.user);
            window.history.replaceState({}, "", window.location.pathname);
          } catch (e) {
            setError(formatApiError(e));
            setUser(null);
          }
        })();
        return;
      }
    }
    load();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("nh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("nh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("nh_token");
    setUser(null);
  };

  const startGoogle = (role = "youth") => {
    localStorage.setItem("nh_google_role", role);
    const redirect = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const refresh = load;

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, startGoogle, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
